<template>
  <div class="solutions-container">
    <!-- 顶部标题区域 -->
    <div class="title-section">
      <h1 class="main-title">产品及解决方案</h1>
      <p class="subtitle">恒毅新生物为您提供基因编辑一站式技术服务</p>
    </div>

    <!-- 解决方案图片区域 -->
    <div class="solutions-grid">
      <div 
        v-for="(solution, index) in solutions" 
        :key="index" 
        class="solution-item"
        @click="handleSolutionClick(solution)"
      >
        <div class="solution-image">
          <img v-lazy="solution.image" :alt="solution.title" />
          <div class="solution-content">
            <h3 class="solution-title">{{ solution.title }}</h3>
            <div class="more-button">
              <span>更多</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cases",
  data() {
    return {
      solutions: [
        {
          title: "核心载体构建",
          image: require("../../assets/img/solution1.png"),
          link: "/product/42"
        },
        {
          title: "细胞模型构建", 
          image: require("../../assets/img/solution2.png"),
          link: "/product/43"
        },
        {
          title: "CRISPR文库筛选",
          image: require("../../assets/img/solution3.png"),
          link: "/product/44"
        },
        {
          title: "基因编辑有效性检测",
          image: require("../../assets/img/solution4.png"),
          link: "/product/52"
        },
        {
          title: "基因编辑安全性评估",
          image: require("../../assets/img/solution5.png"),
          link: "/product/53"
        }
      ]
    };
  },
  methods: {
    handleSolutionClick(solution) {

      if (solution.link) {
        this.$router.push(solution.link);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.solutions-container {
  width: 100%;
  min-height: 100vh;
  // background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 9.25rem 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  gap: 2rem;
}

.title-section {
  text-align: center;
  height: 10rem;
  padding: 0 20px;
  
  .main-title {
    font-size: 2.5rem; // 48px -> 3rem
    font-weight: 600;
    color: #000;
    margin-bottom: 1.5625rem; // 25px -> 1.5625rem
    position: relative;
    /* 可以根据需要调整文字与横线的距离 */
    padding-bottom: 1.25rem; // 20px -> 1.25rem

      &::after {
      /* 伪元素必须设置content属性 */
      content: '';
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: 0;
      width: 100px;
      height: 3px;
      background-color: #000;
    }
  }
  
  .subtitle {
    margin-top: 0.625rem; // 10px -> 0.625rem
    font-size: 1.25rem; // 20px -> 1.25rem
    color: #666;
    font-weight: 400;
    line-height: 1.5;
  }
}

.solutions-grid {
  display: flex;
  width: 100%;
  flex: 1;
  margin-bottom:3rem;
  box-sizing: border-box;
  // height: 400px;
}

.solution-item {
  flex: 1;
  cursor: pointer;
  transition: transform 0.3s ease;
  position: relative;
  width: 100%;

  &:hover {
    transform: translateY(-10px);
    
    .solution-content {
      top: 40%;
      transform: translate(-50%, -50%);
    }
    
    .more-button {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

.solution-image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    // object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  &:hover img {
    transform: scale(1.05);
  }
}

.solution-content {
  position: absolute;
  width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  z-index: 2;
}

.solution-title {
  color: #fff;
  font-size: 1.25rem; // 18px -> 1.125rem
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
  padding: 0 0.625rem; // 10px -> 0.625rem
  margin-bottom: 1rem;
}

.more-button {
  padding: 0.25rem 2rem;
  border: 1px solid #fff;
  border-radius: 25px;
  background: transparent;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(10px);
  
  &:hover {
    background: #fff;
    
    span {
      color: #000;
    }
  }
  
  span {
    color: #fff;
    font-size: 1rem; // 16px -> 1rem
    font-weight: 500;
    transition: color 0.3s ease;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .solutions-grid {
    flex-direction: column;
    height: auto;
  }
  
  .solution-item {
    height: 200px;
  }
  
  .title-section {
    .main-title {
      font-size: 2.25rem; // 36px -> 2.25rem
    }
    
    .subtitle {
      font-size: 1.125rem; // 18px -> 1.125rem
    }
  }
}

// 小屏幕设备优化
@media (max-width: 480px) {
  .title-section {
    .main-title {
      font-size: 1.875rem; // 30px
    }
    
    .subtitle {
      font-size: 1rem; // 16px
    }
  }
  
  .solution-title {
    font-size: 1rem; // 16px
  }
}
</style>
